<template>
  <div>
    <CRow>
      <CCol xs="12" sm="12" md="4" lg="4" xl="3">
        <CCard>
          <CCardHeader class="d-flex justify-content-between">
            <b><i class="fas fa-calendar"></i>&nbsp;Compras</b>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol xs="12" sm="12" md="12" lg="12" xxl="12">
                <CInput label="Desde" type="date" aria-label="shift_date" @input="mtd_data" size="sm" id="init"
                  v-model="filter.init" />
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="12" xxl="12">
                <CInput label="Hasta" type="date" aria-label="shift_date" @input="mtd_data" id="end" size="sm"
                  v-model="filter.end" />
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="12" xxl="12">
                <CInput label="Total de Compras" type="text" size="sm" v-model="totalCompras" disabled />
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="12" xxl="12">
                <CInput label="Gasto Total de Compras" type="text" size="sm" v-model="sumaTotalCompras" disabled />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol xs="12" sm="12" md="8" lg="8" xl="9">
        <CTableWrapper :items="data" :fields="fields" hover :striped="true" :border="true" small fixed billing
          caption="Lista de compras" icon="fas fa-coins" @mtdBack="mtdBack" @mtdReport="mtdReport" :size="'md'" :withActions="'2%'"
          :actions="true" :myButtons="myButtons" @mtd_detail_purchase="mtd_detail_purchase">
        </CTableWrapper>
      </CCol>
    </CRow>

  </div>
</template>

<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "campu_name", label: "Sede", _style: "width:10%;" },
  { key: "provider_name", label: "Proveedor", _style: "width:10%;" },
  { key: "detail_purchase", label: "Items", _style: "width:10%;" },
  { key: "method_payment_text", label: "Método de pago", _style: "width:10%;" },
  { key: "document_type_name", label: "Tipo de documento", _style: "width:10%;" },
  { key: "document", label: "N° Documento", _style: "width:10%;" },
  { key: "total", label: "Total", _style: "width:5%;" },
  { key: "date_formatted", label: "Fecha", _style: "width:5%;" },
];

import CTableWrapper from "../../../components/shared/datatable/Table.vue";
import { mapActions } from "vuex";
import moment from "moment";

export default {
  components: {
    CTableWrapper,

  },
  data() {
    return {
      prefix: "purchases",
      fields,
      data: [],
      totalCompras: 0,
      sumaTotalCompras: 0,
      filter: {
        init: null,
        end: null,
      },
      // date: this.getTodayDate(),

      labelIcon: {
        labelOn: "\u2713",
        labelOff: "\u2715",
      },
      componentKey: 0,
      myButtons: [
        {
          class: "btn-sm",
          color: "primary",
          tooltip: "Detalle de la compra",
          action: "mtd_detail_purchase",
          icon: "fas fa-file-pdf",
        },
      ],
    };
  },
  computed: {
    cpStatus: function () {
      if (this.companies.state == 1) return true;
      return false;
    },
  },
  created() {
    moment.locale("es");
    this.filter.end = moment().format("YYYY-MM-DD");
    this.filter.init = this.filter.end;
    this.mtd_data();
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtd_data() {
      if (!this.filter.init || !this.filter.end || this.filter.init > this.filter.end) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Por favor, selecciona un rango de fechas válido.',
        });
      }
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/indexPurchase",
        token: this.$store.getters.get__token,
        params: {
          init: this.filter.init,
          end: this.filter.end,
          campu_id: this.$store.getters.get_campu.id,
          company_id: this.$store.getters.get_company.id,
        },
      })
        .then((response) => {
          this.data = response.data.data;
          this.totalCompras = this.data.length;
          this.sumaTotalCompras = this.data.reduce((sum, item) => sum + parseFloat(item.total || 0), 0).toFixed(2);
          this.data.forEach((item) => {
            item.provider_name = item.provider.name;
            item.campu_name = item.campu.name;
            item.date_formatted = moment(item.date).format("DD/MM/YYYY");
            if (item.method_payment && item.method_payment.name) {
              item.method_payment_text = item.method_payment.name;
            } else {
              item.method_payment_text = 'No especificado';
            }
            if (item.document_type && item.document_type.name) {
              item.document_type_name = item.document_type.name;
            } else {
              item.document_type_name = 'No especificado';
            }
            /* item.detail_purchase = item.detail.map((det) =>
              det.product_unit.product
                ? det.product_unit.product.name
                :  "Item no encontrado"
            ).join(", ") */
            item.detail_purchase = item.detail.map((det) => {
              if (det.product_unit && det.product_unit.product != null) {
                return `[Pro] ${det.product_unit.product.name}`;
              } else if (det.input_unit && det.input_unit.input != null) {
                return `[Ins] ${det.input_unit.input.name}`;
              } else {
                return "Item no encontrado";
              }
            }).join(", ");
          });
          let index = 1;
          this.data.forEach((arr) => {
            arr.index = index;
            index++
          });
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtdBack: function () {
      this.$emit("mtdBack");
    },
    mtd_detail_purchase(item) {
      if (item?.id) {
        window.open(
          this.$store.getters.get__url + "/purchase/detail-purchase/" + item.id + "/" + this.$store.getters.get__user_id,
          "_blank"
        );
      } else {
        Swal.fire({
          icon: "error",
          title: "Error de detalle",
          text: "Está compra no tiene detalles",
        });
      }

    },
    mtdReport: async function () {
      try {
        const ExcelJS = require('exceljs');
        const { saveAs } = require('file-saver');

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Compras');

        worksheet.columns = [
          { header: 'ID', key: 'id', width: 5 },
          { header: 'SEDE', key: 'campu_name', width: 15 },
          { header: 'PROVEEDOR', key: 'provider_name', width: 25 },
          { header: 'ITEMS', key: 'detail_purchase', width: 40 },
          { header: 'MÉTODO DE PAGO', key: 'method_payment_text', width: 18 },
          { header: 'TIPO DE DOCUMENTO', key: 'document_type_name', width: 20 },
          { header: 'N° DOCUMENTO', key: 'document', width: 15 },
          { header: 'TOTAL', key: 'total', width: 12 },
          { header: 'FECHA', key: 'date_formatted', width: 12 },
        ];

        const headerRow = worksheet.getRow(1);
        headerRow.font = { bold: true };
        headerRow.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'D9E1F2' },
        };
        headerRow.alignment = { horizontal: 'center', vertical: 'center', wrapText: true };
        headerRow.height = 30;

        headerRow.eachCell((cell) => {
          cell.border = {
            top:    { style: 'thin' },
            left:   { style: 'thin' },
            bottom: { style: 'thin' },
            right:  { style: 'thin' },
          };
        });

        this.data.forEach((item, index) => {
          const row = worksheet.addRow({
            id: index + 1,
            campu_name: item.campu_name || '-',
            provider_name: item.provider_name || '-',
            detail_purchase: item.detail_purchase || '-',
            method_payment_text: item.method_payment_text || '-',
            document_type_name: item.document_type_name || '-',
            document: item.document || '-',
            total: parseFloat(item.total || 0),
            date_formatted: item.date_formatted || '-',
          });

          row.eachCell((cell) => {
            cell.border = {
              top:    { style: 'thin' },
              left:   { style: 'thin' },
              bottom: { style: 'thin' },
              right:  { style: 'thin' },
            };
          });
        });

        worksheet.getColumn('H').numFmt = '#,##0.00';

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        saveAs(blob, `Reporte_Compras_${this.filter.init}_al_${this.filter.end}.xlsx`);
      } catch (error) {
        console.error("Error al generar reporte:", error);
        Swal.fire({
          title: "Error al generar el reporte",
          text: error.message,
          icon: "error",
        });
      }
    },
  },

};
</script>

<style lang="scss" scoped></style>